/** @format */

// material
import { alpha, styled } from "@mui/material/styles";
import { Box, Card, Typography, Stack } from "@mui/material";
import Iconify from "../../components/Iconify";
import moment from "moment";

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: "none",
  textAlign: "center",
  padding: theme.spacing(3, 1),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.primary.lighter,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
}));

const IconWrapperStyle = styled("div")(({ theme }) => ({
  margin: "auto",
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  width: theme.spacing(5),
  height: theme.spacing(5),
  // marginBottom: theme.spacing(2),
  color: theme.palette.info.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(
    theme.palette.info.dark,
    0
  )} 0%, ${alpha(theme.palette.info.dark, 0.24)} 100%)`,
}));

// ----------------------------------------------------------------------

// const TOTAL = 3249;

export default function CardBilling(props) {
  const { value, icon, title, valid } = props;

  return (
    <RootStyle>
      <Stack justifyContent={"center"} alignItems={"start"}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {icon && (
            <IconWrapperStyle>
              <Iconify icon={icon} width={20} height={20} />
            </IconWrapperStyle>
          )}
          <Box sx={{ marginLeft: "10px" }}>
            {title && (
              <Typography
                sx={{
                  opacity: 0.72,
                  fontSize: "12px",
                  fontWeight: "bold",
                  wordWrap: "break-word",
                  textAlign: "start",
                }}
              >
                {title}
                {/* Total Business Initiated */}
              </Typography>
            )}
            {value && <Typography variant="h4">{value}</Typography>}
          </Box>
        </Box>
        {valid && (
          <Typography
            sx={{
              marginTop: "15px",
              opacity: 0.72,
              fontSize: "12px",
              fontWeight: "bold",
              wordWrap: "break-word",
              textAlign: "start",
            }}
          >
            {`Valid until ${moment(valid).format("DD MMMM YYYY")}`}
          </Typography>
        )}
      </Stack>
    </RootStyle>
  );
}
